/**
 * FlagsNotesTab — workflow flags + note + quality_des_contract (textarea lớn).
 */
import { Box, Checkbox, FormControlLabel, FormGroup, TextField } from '@mui/material'
import { Controller, type Control, type FieldErrors } from 'react-hook-form'

import type { LocalPFormValues } from './types'

export interface FlagsNotesTabProps {
  control: Control<LocalPFormValues>
  errors: FieldErrors<LocalPFormValues>
}

const FLAGS: Array<{ name: keyof LocalPFormValues; label: string }> = [
  { name: 'is_issued', label: 'Issued (đã phát hành)' },
  { name: 'is_sent_mail', label: 'Sent Mail' },
  { name: 'is_received_mail', label: 'Received Mail' },
  { name: 'is_sent_paper', label: 'Sent Paper' },
  { name: 'is_received_paper', label: 'Received Paper' },
]

export function FlagsNotesTab({ control, errors }: FlagsNotesTabProps) {
  return (
    <Box display="flex" flexDirection="column" gap={2} pt={1}>
      <FormGroup row>
        {FLAGS.map((f) => (
          <Controller
            key={f.name as string}
            control={control}
            name={f.name as keyof LocalPFormValues}
            render={({ field }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                  />
                }
                label={f.label}
              />
            )}
          />
        ))}
      </FormGroup>

      <Controller
        control={control}
        name="quality_des_contract"
        render={({ field }) => (
          <TextField
            {...field}
            label="Quality Description (in hợp đồng)"
            size="small"
            fullWidth
            multiline
            minRows={4}
            error={!!errors.quality_des_contract}
            helperText={errors.quality_des_contract?.message}
          />
        )}
      />

      <Controller
        control={control}
        name="note"
        render={({ field }) => (
          <TextField
            {...field}
            label="Ghi chú"
            size="small"
            fullWidth
            multiline
            minRows={3}
            error={!!errors.note}
            helperText={errors.note?.message}
          />
        )}
      />
    </Box>
  )
}

export default FlagsNotesTab
